export default __webpack_public_path__ + "static/media/adobe.11e1a969.png";